import React from "react";
import "./PersonalInfo.css";
import AboutImg from "../../images/about_images/about_img.png";
import Buttons from "../Buttons/index";
import { FaUser } from "react-icons/fa";

const PersonalInfo = () => {
  return (
    <div className="Personal_Info">
      <div className="about_img_box">
        <div className="about_img">
          <img src={AboutImg} alt="dark-about" />
        </div>
      </div>
      <div className="about_info">
        <div className="infos">
          <ul>
            <AboutInfoLi infoOne="First Name" infoTwo="Sahriar Alam" />
            <AboutInfoLi infoOne="Last Name" infoTwo="Ovi" />
            <AboutInfoLi infoOne="Birthdate" infoTwo="08 july 2001" />
            <AboutInfoLi infoOne="Nationality" infoTwo="Bangladeshi" />
            <AboutInfoLi infoOne="Experience" infoTwo="3 years" />
            <AboutInfoLi infoOne="Address" infoTwo="Chittagong, Bangladesh" />
          </ul>
          <ul>
            <AboutInfoLi infoOne="Freelance" infoTwo="Available" />
            <AboutInfoLi infoOne="Languages" infoTwo="Bengali, English" />
            <AboutInfoLi infoOne="Phone" infoTwo="+880 1881796126" />
            <AboutInfoLi infoOne="Email" infoTwo="sahriarovi123@gmail.com" />
            <AboutInfoLi infoOne="Facebook" infoTwo="Mohammad Ovi" />
            <AboutInfoLi infoOne="Linkedin" infoTwo="Sahriar Ovi" />
          </ul>
        </div>
        <div className="section_btns">
          <Buttons
            btnIcon={<FaUser />}
            btntext={"more about me"}
            href="/contact"
          />
        </div>
      </div>
    </div>
  );
};

const AboutInfoLi = (props) => {
  return (
    <li>
      <h4>
        {props.infoOne} <span>{props.infoTwo}</span>
      </h4>
    </li>
  );
};

export default PersonalInfo;
